<template>
  <el-card >
    <!-- 查询表单 -->
    <el-form :inline="true" class="search-form">
      <el-form-item>
        <el-button type="primary" @click="onSearch">刷新</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleCreateSafeGrade">创建</el-button>
      </el-form-item>
    </el-form>
    <!-- 角色表格 -->
    <el-table
      :data="tableData"
      :stripe ="true"
      :border = "true"
      height="calc(100vh - 200px)"
      max-height="calc(100vh - 200px)"
      :highlight-current-row ="true"
      :header-cell-style="{'text-align':'center'}"
      :cell-style="{'text-align':'center'}"
      style="width: 90%">
      <el-table-column
        type="index"
        label="序号"
        :index="indexMethod">
      </el-table-column>
      <el-table-column
        prop="safeGrade"
        label="安全等级"
        min-width="150px">
      </el-table-column>
      <el-table-column
        prop="remark"
        min-width="200px"
        label="备注" >
      </el-table-column>
      <el-table-column
        prop="createUser"
        label="创建者"
        width="120">
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        min-width="150px">
      </el-table-column>
      <el-table-column
        prop="updateUser"
        width="120"
        label="更新者">
      </el-table-column>
      <el-table-column
        prop="updateTime"
        min-width="150px"
        label="更新时间">
      </el-table-column>
     
      <el-table-column label="操作" min-width="120px" >
        <template slot-scope="scope" >
          <el-dropdown split-button type="primary" @command="handleCommand">
            管理
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item divided :command = '{event:"delete", index:scope.$index,data:scope.row}'><i class="el-icon-delete-solid" style="color:rgb(246, 102, 18)" ></i> <span>删除安全等级</span></el-dropdown-item>
              <el-dropdown-item divided :command = '{event:"edit",index:scope.$index, data:scope.row}'><i class="el-icon-document" style="color:rgb(40, 238, 10)" ></i> <span>修改安全等级</span></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <!-- 修改权限弹框 -->
    <el-dialog :visible.sync="dialogVisual.editSafeGradeDialogVisible" v-on:close ="clearEditSafeGradeInfoForm" >
      <div slot="title" class="dialog-footer">
          <span> 角色[{{ editSafeGradeForm.safeGrade }}] 信息变更 </span>
      </div>
      <el-form :model="editSafeGradeForm" label-width="20%"> 
        <el-form-item label="角色名称:"  style="width: 80%">
          <el-input v-model="editSafeGradeForm.safeGrade" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="备注:" style="width: 80%">
          <el-input type="textarea" v-model="editSafeGradeForm.remark" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="ensureChange">确定变更</el-button>
      </div>
    </el-dialog>
    <!-- 创安全等级弹框 -->
    <el-dialog :visible.sync="dialogVisual.createSafeGradeDialogVisible" v-on:close ="clearCreateSafeGradeInfoForm" >
      <div slot="title" class="dialog-footer">
          <span> 创建安全等级信息 </span>
      </div>
      <el-form :model="createSafeGradeForm" label-width="20%"> 
        <el-form-item label="安全等级:" style="width: 80%" >
          <el-input v-model="createSafeGradeForm.safeGrade" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="备注:" style="width: 80%">
          <el-input type="textarea" v-model="createSafeGradeForm.remark" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="ensureCreate">创建安全等级</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>                     
<script>
import axios from  '@/api/axiosConfig'
import {stringIsNullOrEmpty} from  '@/api/utils'
import {MESSAGE_DURATION} from  '@/api/constant'
export default {
    name : 'pc_ctr_sage_grade',
    data() {
    return {
      tableData: [],
      dialogVisual:{
        editRoleDialogVisible: false,
        createSafeGradeDialogVisible: false
      },
      editSafeGradeForm: {
        safeGrade: '',
        remark: '',
        id :''
      },
      createSafeGradeForm: {
        safeGrade: '',
        remark: ''
      }
    }
  },
  methods : {
    handleCommand(command){
      let index  = command.index
      let row = command.data
      let event = command.event
      switch(event){
        case 'delete' :
            this.handleDelete(index,row)
            break
        case 'edit' :
            this.handleEdit(index,row)
            break
      }
    },
    indexMethod(index){
      return  index + 1
    },
    safeGradeListLoad(){
      let url = "/bc/exa/safeGrade/all"
      let dat0 = {  
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data;
          if(dat.data.length !== 0){
            this.tableData = [];
            dat.data.forEach(t=>this.tableData.push(t))
          } else {
            this.$message({
              showClose: true,
              message: '未查询到安全等级信息！',
              type: 'info',
              duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch( (err) => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
      });
    },
    clearEditSafeGradeInfoForm(){
      this.editSafeGradeForm.safeGrade = ''
      this.editSafeGradeForm.remark = ''
      this.editSafeGradeForm.id = ''
    },
    clearCreateSafeGradeInfoForm(){
      this.createSafeGradeForm.safeGrade = ''
      this.createSafeGradeForm.remark = ''
    },
    onSearch(){
      this.safeGradeListLoad()
    },
    handleEdit(index, row){
      this.dialogVisual.editSafeGradeDialogVisible = true
      this.editSafeGradeForm.safeGrade = row.safeGrade
      this.editSafeGradeForm.remark = row.remark
      this.editSafeGradeForm.id = row.id
    },
    handleCreateSafeGrade(){
      this.dialogVisual.createSafeGradeDialogVisible = true
    },
    ensureChange(){
      this.$confirm('即将更新安全等级['+this.editSafeGradeForm.safeGrade+']信息', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.doChangeSafeGradeInfo()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消更新！'
        });
      })
    },
    doChangeSafeGradeInfo(){
      let url = "/bc/exa/safeGrade/safeGradeEdit"
      let s = JSON.stringify(this.editSafeGradeForm)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.dialogVisual.editSafeGradeDialogVisible= false;
          this.clearEditSafeGradeInfoForm();
          this.$message({
            showClose: true,
            message: '更新成功',
            type: 'success',
            duration: MESSAGE_DURATION
          })
          this.safeGradeListLoad()
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
    ensureCreate(){
      try{ 
        stringIsNullOrEmpty(this.createSafeGradeForm.safeGrade,'请输安全等级!');
        stringIsNullOrEmpty(this.createSafeGradeForm.remark,'请输入备注信息!');
      }catch (e){
        this.$message({
          showClose: true,
          message: e,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
        return
      }
      this.doCreateSafeGradeInfo();
    },
    doCreateSafeGradeInfo(){
      let url = "/bc/exa/safeGrade/safeGradeCreate"
      let s = JSON.stringify(this.createSafeGradeForm)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.dialogVisual.createSafeGradeDialogVisible = false
          this.clearCreateSafeGradeInfoForm()
          this.$message({
            showClose: true,
            message: '创建成功',
            type: 'success',
            duration: MESSAGE_DURATION
          })
          this.safeGradeListLoad()
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    }, 
    handleDelete(index, row){
      this.$confirm('即将删除安全等级['+row.safeGrade+']信息', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.doDeleteSafeGrade(row)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消删除！'
        });
      })
    },
    doDeleteSafeGrade(row){
      let dat = {id: row.id}
      let url = "/bc/exa/safeGrade/safeGradeDelete"
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.$message({
            showClose: true,
            message: '删除成功!',
            type: 'success',
            duration: MESSAGE_DURATION
          })
          this.safeGradeListLoad()
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    }
  },
  created () {
    this.safeGradeListLoad()
  }
}
</script>

<style lang="less" scoped>
.el-card {
  height: 99%
}

.search-form{
  margin-top: 10px;
  text-align:left 
}

.text {
  font-size: 14px;
  color: #000;
}
</style>
    


// WEBPACK FOOTER //
// src/pc_pages/pc_ctr_component/pc_ctr_safe_grade.vue